// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Card/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.333 6.292c0 .55-.45 1-1 1H2.667c-.55 0-1-.45-1-1v-.009a3.446 3.446 0 0 1 3.45-3.45h9.758a3.46 3.46 0 0 1 3.458 3.459ZM1.667 9.542v4.175a3.446 3.446 0 0 0 3.45 3.45h9.758a3.46 3.46 0 0 0 3.458-3.459V9.542c0-.55-.45-1-1-1H2.667c-.55 0-1 .45-1 1Zm5 4.833H5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h1.667a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Zm5.416 0H8.75a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h3.333a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default CardIcon;